import React from "react";
import './experience.css'
import { experience } from "../../data/profile";


const Experience = () => {
    return(
        <section id="experience">
            <div className="container">
                <span className="section__eyebrow">Career</span>
                <h2 className="section__title">Experience</h2>

                <ol className="experience__timeline">
                    {experience.map(({ company, role, start, end, groups }) => (
                        <li key={company} className="experience__item reveal">
                            <div className="experience__header">
                                <div>
                                    <h3>{role}</h3>
                                    <p className="experience__company">{company}</p>
                                </div>
                                <span className="experience__dates text-muted">{start} – {end}</span>
                            </div>

                            <div className="experience__groups">
                                {groups.map(({ title, points }) => (
                                    <div key={title}>
                                        <h4>{title}</h4>
                                        <ul className="experience__points text-muted">
                                            {points.map((point) => <li key={point}>{point}</li>)}
                                        </ul>
                                    </div>
                                ))}
                            </div>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    )
}

export default Experience
